module.exports = __webpack_public_path__ + "img/itx-text-h6.4f2ed907.svg";